<div class="grid-container padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">BILL OF LADING</legend>
  </div>
  <form [formGroup]="billOfLadingForm">
    @if (hhgBillOfLadingReview$ | async) {
      <div class="grid-row grid-gap-1" id="BOLInformation">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="bookShipmentId" class="usa-label">Shipment Id</label>
          <input type="text" class="usa-input maxw-full" id="bookShipmentId" formControlName="bookShipmentId" />
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="billOfLadingNbr" class="usa-label">Bill of Lading No.</label>
          <input type="text" class="usa-input maxw-full" id="billOfLadingNbr" formControlName="billOfLadingNbr" />
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="bolIssuedDate" class="usa-label">Date BL Issued</label>
          <input type="text" class="usa-input maxw-full" id="bolIssuedDate" formControlName="bolIssuedDate" />
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="bolStatus" class="usa-label">Status</label>
          <input type="text" class="usa-input maxw-full" id="bolStatus" formControlName="billOfLadingStatus" />
        </div>
      </div>
    }
    <div class="padding-y-4">
      <div class="usa-accordion usa-accordion--bordered">
        <h4 class="usa-accordion__heading">
          <button class="usa-accordion__button" aria-expanded="false" aria-controls="TSPandFurnished">
            TSP & Furnished Information On Shipments
          </button>
        </h4>
        <div id="TSPandFurnished" class="usa-accordion__content usa-prose">
          <app-billoflading-information formControlName="billOfLadingInfo" [shipmentInfoIdFromUrl]="shipmentInfoIdFromUrl" [routedFrom]="screenRoutedFrom" [selectedShipmentType]="selectedShipmentType">
          </app-billoflading-information>
        </div>

        <h4 class="usa-accordion__heading">
          <button class="usa-accordion__button" aria-expanded="false" aria-controls="ShipmentInformation">
            Shipment Information
          </button>
        </h4>
        <div id="ShipmentInformation" class="usa-accordion__content usa-prose">
          <app-billoflading-shipment-information formControlName="billOfLadingShipmentInfo" [routedFrom]="screenRoutedFrom" [selectedShipmentType]="selectedShipmentType" [selectedVehicleType]="selectedVehicleType">
          </app-billoflading-shipment-information>
        </div>

        <h4 class="usa-accordion__heading">
          <button class="usa-accordion__button" aria-expanded="false" aria-controls="AccessorialInformation">
            Accessorial Information
          </button>
        </h4>
        @if (shipmentInfoIdFromUrl) {
          <div id="AccessorialInformation" class="usa-accordion__content usa-prose">
            <app-hhg-shipment-accessorials [routedFrom]="'bol'" [shipmentInfoIdFromUrl]="shipmentInfoIdFromUrl">
            </app-hhg-shipment-accessorials>
          </div>
        }

        <h4 class="usa-accordion__heading">
          <button class="usa-accordion__button" aria-expanded="false" aria-controls="AdditionalRemarks">
            Additional Remarks
          </button>
        </h4>
        @if (shipmentInfoIdFromUrl) {
          <div id="AdditionalRemarks" class="usa-accordion__content usa-prose">
            <app-billoflading-finalization [additionalRemarks]="additionalRemarks" [billOfLadingNbr]="billOfLadingNbr" formControlName="billOfLadingShipmentFinalization">
            </app-billoflading-finalization>
          </div>
        }

      </div>
    </div>
    <div class="grid-row grid-gap-1">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <button class="usa-button" [disabled]="billOfLadingForm.invalid" (click)="saveBillOfLading()">Save</button>
        @if (this.billOfLadingNbr != null && this.billOfLadingNbr != '') {
          <button class="usa-button usa-button margin-left-2" [disabled]="billOfLadingForm.invalid" (click)="generateHHGCorrectionNoticePDF()">
            Generate Correction Notice
          </button>
        }
        <button class="usa-button usa-button margin-left-2" (click)="goBackToPreviousPage()">
          Back to Book Shipments
        </button>
        @if (((this.billOfLadingNbr == null || this.billOfLadingNbr == '') && this.isHHGSelected)) {
          <button class="usa-button usa-button margin-left-2" [disabled]="billOfLadingForm.invalid" (click)="generateBillOfLadingPDF('previewHHG', 'HHG')">
            Preview Bill Of Lading
          </button>
        }
        @if (((this.billOfLadingNbr == null || this.billOfLadingNbr == '') && this.isHHGSelected)) {
          <button class="usa-button usa-button margin-left-2" [disabled]="billOfLadingForm.invalid" (click)="generateBillOfLadingPDF('generateHHG', 'HHG')">
            Generate Bill Of Lading
          </button>
        }
      </div>
    </div>
  </form>
</div>